import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import voidPhotoIcon from '../../images/management/clinicMembers/voidPhoto.png'
import './AvailabilityTableItem.scss'
import stick from '../../images/common/stick.png'
import goToArrowIcon from '../../images/management/serviceTypes/goToArrow.png'
import clockIcon from '../../images/common/clockIcon.png'
import blockIcon from '../../images/common/blockIcon.png'
import FullTextPositionToolTip from '../FullTextPositionToolTip/FullTextPositionToolTip'

import errorIcon from '../../images/common/error-icon.svg'
import {
  AVAILABILITY_TABLE_ITEM_AVAILABILITIES_TOOLTIP_CHECK_POINT,
  AVAILABILITY_TABLE_ITEM_LICENSE_STATES_TOOLTIP_CHECK_POINT,
  AVAILABILITY_TABLE_ITEM_PROVIDER_NAME_TOOLTIP_CHECK_POINT,
  AVAILABILITY_TABLE_ITEM_UNAVAILABILITIES_TOOLTIP_CHECK_POINT,
  AVAILABILITY_TABLE_ITEM_VISIT_TYPES_TOOLTIP_CHECK_POINT,
} from '../../utils/constants'
import { text } from './Constants'
import { setCalendarOffsetBeforeNewVisit, setCalendarRangeBeforeNewVisit } from '../../store/calendar/CalendarActions'

const AvailabilityTableItem = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isLastElem,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  ImageUrl,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  FirstName,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  LastName,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Suffix,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Prefix,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Availabilities,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  Unavailabilities,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  LicensedStates,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  VisitTypes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  mouseOutHandler,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  mouseOverHandler,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  appointmentNameToolTipInfo,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  customTimeZone,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  ItemId,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  AccountActive,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onMouseOverHandler = (event, type) => {
    switch (type) {
      case AVAILABILITY_TABLE_ITEM_PROVIDER_NAME_TOOLTIP_CHECK_POINT:
        mouseOverHandler(event, `${Prefix} ${FirstName} ${LastName} ${Suffix}`, 'providerName', ItemId)
        break
      case AVAILABILITY_TABLE_ITEM_AVAILABILITIES_TOOLTIP_CHECK_POINT:
        mouseOverHandler(event, `${Availabilities}`, 'availabilities', ItemId)
        break
      case AVAILABILITY_TABLE_ITEM_UNAVAILABILITIES_TOOLTIP_CHECK_POINT:
        mouseOverHandler(event, `${Unavailabilities}`, 'unavailabilities', ItemId)
        break
      case AVAILABILITY_TABLE_ITEM_LICENSE_STATES_TOOLTIP_CHECK_POINT:
        mouseOverHandler(event, `${LicensedStates}`, 'licensedStates', ItemId)
        break
      case AVAILABILITY_TABLE_ITEM_VISIT_TYPES_TOOLTIP_CHECK_POINT:
        mouseOverHandler(event, `${VisitTypes}`, 'visitTypes', ItemId)
        break
      default:
        break
    }
    return undefined
  }
  const onItemPress = () => {
    dispatch(setCalendarRangeBeforeNewVisit())
    dispatch(setCalendarOffsetBeforeNewVisit(null))
    navigate(`/availability/calendar/${ItemId}`, {
      state: {
        ImageUrl,
        providerId: ItemId,
        providerName: `${Prefix || ''} ${FirstName} ${LastName} ${Suffix || ''}`,
        timezone: customTimeZone,
        search: location.search,
        visitTypes: VisitTypes,
      },
    })
  }

  return (
    <div>
      {appointmentNameToolTipInfo ?
        <FullTextPositionToolTip
          // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
          toolTipContainerPositionStyle={appointmentNameToolTipInfo}
          title={appointmentNameToolTipInfo.title}
        />
      : null}
      <div role='presentation' className='availability-item-container'>
        <div className='availability-item-common-info-block'>
          <div className='availability-item-left-side-block'>
            <div className='availability-photo-block'>
              <img
                className='availability-user-photo-img'
                style={{ borderRadius: ImageUrl ? '50%' : '' }}
                src={ImageUrl || voidPhotoIcon}
                alt='availabilityItemImg'
              />
            </div>
            <div className='main-availability-info-block'>
              <div className='availability-block-full'>
                <div
                  role='presentation'
                  className='availability-name-row-container'
                  onMouseLeave={mouseOutHandler}
                  onMouseOver={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_PROVIDER_NAME_TOOLTIP_CHECK_POINT)}
                  onFocus={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_PROVIDER_NAME_TOOLTIP_CHECK_POINT)}>
                  <div className='flexWrapper'>
                    <div className='firstLastNameAvailabilityBlock-full' id={`firstLastNameBlock${ItemId}`}>
                      <div />
                      {Prefix} {FirstName} {LastName} {Suffix}
                    </div>
                  </div>
                </div>
              </div>
              <div className='availability-unavailability-block-full'>
                {Availabilities ?
                  <>
                    <img className='availability-page-schedule-icon' src={clockIcon} alt='scheduleAvailabilityIcon' />
                    <div
                      onFocus={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_AVAILABILITIES_TOOLTIP_CHECK_POINT)}
                      className={`availabilityScheduleContainer ${!Unavailabilities && 'extended'}`}
                      onMouseLeave={mouseOutHandler}
                      onMouseOver={(e) =>
                        onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_AVAILABILITIES_TOOLTIP_CHECK_POINT)
                      }>
                      <div className='availabilityBlock-full' id={`availabilities${ItemId}`}>
                        <div />
                        {Availabilities}
                      </div>
                    </div>
                  </>
                : null}
                {Unavailabilities ?
                  <>
                    {Availabilities ?
                      <div>
                        <img className='availability-diverse-stick' src={stick} alt='stick' />
                      </div>
                    : null}
                    <img className='availability-page-schedule-icon' src={blockIcon} alt='scheduleAvailabilityIcon' />
                    <div
                      className={`availabilityScheduleContainer ${!Availabilities && 'extended'}`}
                      onMouseLeave={mouseOutHandler}
                      onMouseOver={(e) =>
                        onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_UNAVAILABILITIES_TOOLTIP_CHECK_POINT)
                      }
                      onFocus={(e) =>
                        onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_UNAVAILABILITIES_TOOLTIP_CHECK_POINT)
                      }>
                      <div className='availabilityBlock-full' id={`unavailabilities${ItemId}`}>
                        <div />
                        {Unavailabilities}
                      </div>
                    </div>
                  </>
                : null}
              </div>
              <div
                className='LicensedStatesContainer'
                onMouseLeave={mouseOutHandler}
                onMouseOver={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_LICENSE_STATES_TOOLTIP_CHECK_POINT)}
                onFocus={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_LICENSE_STATES_TOOLTIP_CHECK_POINT)}>
                <div id={`licensedStateBlock${ItemId}`} className='licensedStateBlock-full'>
                  <div />
                  Applicable state(s): {LicensedStates}
                </div>
              </div>
              <div className='availability-last-row'>
                <div
                  className={`VisitTypesContainer ${!AccountActive ? 'availability-not-active' : ''}`}
                  onMouseLeave={mouseOutHandler}
                  onMouseOver={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_VISIT_TYPES_TOOLTIP_CHECK_POINT)}
                  onFocus={(e) => onMouseOverHandler(e, AVAILABILITY_TABLE_ITEM_VISIT_TYPES_TOOLTIP_CHECK_POINT)}>
                  <div id={`visitTypes${ItemId}`} className='visitTypesBlock-full'>
                    <div />
                    Visit type(s): {VisitTypes}
                  </div>
                </div>
                {!AccountActive && (
                  <div className='availability-member-deactivated-container'>
                    <img alt={text.ERROR} className='clinic-memeber-pending-error-img' src={errorIcon} />
                    <label htmlFor='null' className='clinic-member-pending-error-label'>
                      {text.DISABLED_ACCOUNT}
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div role='presentation' onClick={onItemPress}>
            <img src={goToArrowIcon} className='availability-table-item-go-to-arrow-icon' alt='leftArrow' />
          </div>
        </div>
        {!isLastElem && <div className='availability-item-bottom-border' />}
      </div>
    </div>
  )
}

export default AvailabilityTableItem
